const CenterStage = ({ content }) => (
  <div className="stage-scrollable">{content}</div>
);
export default CenterStage;
